module.exports = __webpack_public_path__ + "static/img/download-tips.f66f485.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/download-tips.png
// module id = 904
// module chunks = 1